// Thin wrappers over the <audio> element the remote stream plays through.
// Kept separate so the store never touches DOM details directly.

export function attachStreamToAudioElement(element, stream) {
  if (!element || !stream) {
    return;
  }

  // Reassigning the same stream restarts playback, so only set on change.
  if (element.srcObject !== stream) {
    element.srcObject = stream;
  }
  element.autoplay = true;
}

export async function playAudioElement(element, onPlaybackStart) {
  if (!element) {
    return;
  }

  await element.play();
  onPlaybackStart?.('audio.play()');
}

export function stopAudioElement(element) {
  if (!element) {
    return;
  }

  try {
    element.pause();
  } catch (_error) {
    // Already torn down.
  }
  element.srcObject = null;
}

/**
 * Listens for the element actually starting playback. Always returns a cleanup
 * function — including when there is no element — so callers never have to
 * null-check before unbinding.
 */
export function bindPlaybackListeners(element, onPlaybackStart) {
  if (!element) {
    return () => {};
  }

  const handlePlaying = () => onPlaybackStart?.('audio.playing');
  element.addEventListener('playing', handlePlaying);

  return () => {
    element.removeEventListener('playing', handlePlaying);
  };
}
